import { render } from "./FileDetailsDialog.vue?vue&type=template&id=5971d69f&scoped=true"
import script from "./FileDetailsDialog.vue?vue&type=script&lang=js"
export * from "./FileDetailsDialog.vue?vue&type=script&lang=js"

import "./FileDetailsDialog.vue?vue&type=style&index=0&id=5971d69f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5971d69f"]])

export default __exports__